import { Config } from "@/shared/config";
import { AppInfo, DevicePlatform } from "@/shared/types";

const cordova = (window as any).cordova;
const capacitor = (window as any).Capacitor;

export function isMobileApp () {
    return !!Config.Mobile.AppId;
}

export function getAuthType () {
    return Config.Mobile.AuthType;
}

export const NativePlatform = () => {
    if (capacitor && capacitor.getPlatform()) {
        return capacitor.getPlatform().toLowerCase();
    }
    if (cordova && cordova.platformId) {
        return cordova.platformId.toLowerCase();
    }
    return "";
};

const getDevicePlatform = (): DevicePlatform => {
    const platform = NativePlatform();
    if (platform === "android") return DevicePlatform.Android;
    if (platform === "ios") return DevicePlatform.iOS;
    return DevicePlatform.Unknown;
};

export const mobileAppInfo = (): AppInfo => {
    return {
        platform: getDevicePlatform(),
        name: Config.Mobile.AppName,
        version: Config.Mobile.AppVersion,
        isMobile: true
    };
};

export const mobilePlugins = capacitor && capacitor.Plugins;

export async function openFileViewer (url: string) {
    await mobilePlugins.FileViewer.openDocumentFromUrl({ url });
}

export function isCapacitorAvailable (): boolean {
    return capacitor && capacitor !== undefined;
}
